
// document.addEventListener('DOMContentLoaded', function () {
//     var swiperHero = new Swiper('.hero-slider .slider-container', {
//         loop: true,
//         autoplay: {
//             delay: 5000,
//             disableOnInteraction: false,
//         },
//         slidesPerView: 'auto',
//         speed: 1500,
//         grabCursor: true,
//         mousewheelControl: true,
//         keyboardControl: true,
//     });
// });

$(document).ready(function () {
  $('.slider-wrapper').slick({
    autoplay: true,
    dots: false,
    speed: 1000,
    autoplaySpeed: 500,
    infinite: true,
    slidesToShow: 6,
    pauseOnHover: false,
    pauseOnFocus: false,
    slidesToScroll: 1,
    arrows: false,
    touchThreshold: 300,
    centerMode: true, 
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 875,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 681,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 535,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 486,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,

        }
      },
      {
        breakpoint: 416,
        settings: {
          slidesToShow:  1,
          slidesToScroll: 1,

        }
      }
     
    ]
  });

  $('.slider-prev').click(function () {
    $(this).closest('.section').find(".list").slick('slickPrev');
  });

  $('.slider-next').click(function () {
    $(this).closest('.section').find(".list").slick('slickNext');
  });
});

